import { render } from "./ProductAttributes.vue?vue&type=template&id=da993704&scoped=true"
import script from "./ProductAttributes.vue?vue&type=script&lang=js"
export * from "./ProductAttributes.vue?vue&type=script&lang=js"

import "./ProductAttributes.vue?vue&type=style&index=0&id=da993704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da993704"]])

export default __exports__